import React from "react";
import { convertToDateMonthFormat } from "../../utils/ConvertDate";

export const exportExcel = async (data: any) => {
  import("xlsx").then((xlsx) => {
    const parseData = data.map((item: any) => {
      return {
        Name: item.policyName,
        Version: item.policyVersion + "",
        Status: item.policyStatus,
        Created: convertToDateMonthFormat(item.createDate),
        Approved: convertToDateMonthFormat(item.policyApprovalDate),
      };
    });

    const worksheet = xlsx.utils.json_to_sheet(parseData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Policy");

    /* calculate column width */
    worksheet["!cols"] = Object.keys(parseData[0]).map((ele) => ({
      wch: ele === "Name" ? 30 : 15,
    }));

    xlsx.writeFile(workbook, "Policies.xlsx", { compression: true });
  });
};
